(function () {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    /**
     * A directive that gives access to a file object. Used for file upload. From a directive by Jenny Louthan posted at
     * http://uncorkedstudios.com/blog/multipartformdata-file-upload-with-angularjs.
     * @example
     * Usage:
     * <input type="file" file-model="imageFile">;
     * <button ng-click="doSomethingWithFile(imageFile)">Use File<bbutton>;
     */
    angular
        .module('ihh-common-web')
        .directive('fileModel', fileModel);

    fileModel.$inject = ['$parse'];

    function fileModel($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind('change', function() {
                    scope.$apply(function() {
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }
})();
